import React, { useState } from 'react';
import { change, Field, reduxForm } from 'redux-form';
import { Col, Row, Card, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import PersonIcon from '@mui/icons-material/Person';
import BadgeIcon from '@mui/icons-material/Badge';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DomainIcon from '@mui/icons-material/Domain';
import MapIcon from '@mui/icons-material/Map';
import MarkAsUnreadIcon from '@mui/icons-material/MarkAsUnread';
import LayersIcon from '@mui/icons-material/Layers';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import SmartphoneIcon from '@mui/icons-material/Smartphone';

import renderSelectField from 'src/shared/components/form/Select';
import renderField from 'src/shared/components/form/renderField';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { showNotification } from 'src/shared/components/Notification';
import { connect } from 'react-redux';
import MerchantCustomerAddNewAddressModal from './MerchantCustomerAddNewAddressModal';
import MerchantCustomerAddressChangeModal from './MerchantCustomerAddressChangeModal';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';

const required = value => (value ? undefined : 'Required');

const MerchantDropOffRequiredLaterCustomerInfo = ({ dispatch, isCustomersId }) => {
    const [isPopUpCustomer, setPopUpCustomer] = useState(false);
    const [isMerchantCustomerAddress, setMerchantCustomerAddress] = useState(false);
    const [merCustomerId, setMerCustomerId] = useState(null);

    const getMerchantCustomersInfoById = async (event) => {
        try {
            setMerCustomerId(event?.value);
            const response = await PndRestApi.GetMerchantCustomerById(localStorage.getItem('mi'), event?.value);
            if (response.status === 200 && response.data.status === 200 && response.data.data.length > 0) {
                const data = response.data.data[0];
                dispatch(change('orderForm', 'toAddressShortCode', data.merchantCustomerCode));
                dispatch(change('orderForm', 'toAddress', data.address));
                dispatch(change('orderForm', 'toAddressBuildingName', data.buildingName));
                dispatch(change('orderForm', 'toAddressContactNumber', data.mobileNo));
                dispatch(change('orderForm', 'toAddressPostalCode', data.poBoxNo));
                dispatch(change('orderForm', 'toAddressDoorNo', data.doorNo));
                dispatch(change('orderForm', 'toAddressFloorNo', data.floorNo));
                if (data.contactName) {
                    dispatch(change('orderForm', 'toAddressContactPersonName', data.contactName));
                }
                dispatch(change('orderForm', 'toAddressGrlCode', data.grl));
                if (data.area) dispatch(change('orderForm', 'toAddressAreaName', data.area));
            } else {
                ['toAddressShortCode', 'toAddress', 'toAddressBuildingName', 'toAddressContactNumber', 'toAddressPostalCode', 'toAddressDoorNo', 'toAddressFloorNo', 'toAddressAreaName', 'toAddressContactPersonName', 'toAddressGrlCode'].forEach(field => {
                    dispatch(change('orderForm', field, ""));
                });
                showNotification("theme-light", "ltr", `SuccessCode: ${response.data.status}`, `Message:${response.data.message}`);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification("theme-light", "ltr", "SuccessCode: 500", ERROR_MESSAGES.tryCatchError);
        }
    };

    return (
        <Card className="border-0 shadow-sm mb-3 bg-light bg-opacity-10 border-start border-primary border-4">
            <CardBody className="p-3">
                <div className="d-flex align-items-center mb-3 text-primary border-bottom pb-2">
                    <PersonIcon style={{ fontSize: '1.2rem' }} className="me-2" />
                    <h6 className="m-0 fw-bold small text-uppercase">Drop Off Customer Information (Secondary)</h6>
                </div>
                <Row className="g-2 mb-2">
                    <Col lg={4} md={6}>
                        <div className="mb-1">
                            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Customer Name <span className='text-danger'>*</span></label>
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1">
                                    <Field name="toAddressName" component={renderSelectField} options={isCustomersId} placeholder="Select Customer" onChange={getMerchantCustomersInfoById} validate={[required]} />
                                </div>
                                <Tooltip title="Add New Customer">
                                    <Fab color="success" size="small" className="ms-1" style={{ width: '30px', height: '30px', minHeight: '30px' }} onClick={() => setPopUpCustomer(true)}>
                                        <AddIcon style={{ fontSize: '1rem' }} />
                                    </Fab>
                                </Tooltip>
                            </div>
                        </div>
                    </Col>
                    <Col lg={2} md={6}>
                        <div className="mb-1">
                            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Customer Code</label>
                            <Field name="toAddressShortCode" component={renderField} type="text" placeholder="Code" icon={BadgeIcon} disabled={true} />
                        </div>
                    </Col>
                    <Col lg={6} md={12}>
                        <div className="mb-1">
                            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Full Address <span className='text-danger'>*</span></label>
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1">
                                    <Field name="toAddress" component={renderField} type="textarea" placeholder="Address" validate={[required]} icon={LocationOnIcon} />
                                </div>
                                <Tooltip title="Change Address">
                                    <Fab color="success" size="small" className="ms-1" style={{ width: '30px', height: '30px', minHeight: '30px' }} onClick={() => setMerchantCustomerAddress(true)}>
                                        <EditIcon style={{ fontSize: '1rem' }} />
                                    </Fab>
                                </Tooltip>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="g-2 mb-2">
                    <Col lg={4} md={6}>
                        <div className="mb-1">
                            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Building Name <span className='text-danger'>*</span></label>
                            <Field name="toAddressBuildingName" component={renderField} type="text" placeholder="Building Name" validate={[required]} icon={DomainIcon} />
                        </div>
                    </Col>
                    <Col lg={2} md={6}>
                        <div className="mb-1">
                            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Area</label>
                            <Field name="toAddressAreaName" component={renderField} type="text" placeholder="Area" validate={[required]} icon={MapIcon} />
                        </div>
                    </Col>
                    <Col lg={2} md={6}>
                        <div className="mb-1">
                            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>GRL</label>
                            <Field name="toAddressGrlCode" component={renderField} type="text" placeholder="GRL" disabled={true} icon={MarkAsUnreadIcon} />
                        </div>
                    </Col>
                    <Col lg={2} md={6}>
                        <div className="mb-1">
                            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Floor Number</label>
                            <Field name="toAddressFloorNo" component={renderField} type="text" placeholder="Floor" icon={LayersIcon} />
                        </div>
                    </Col>
                    <Col lg={2} md={6}>
                        <div className="mb-1">
                            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Door Number</label>
                            <Field name="toAddressDoorNo" component={renderField} type="text" placeholder="Door No." icon={MeetingRoomIcon} />
                        </div>
                    </Col>
                </Row>
                <Row className="g-2">
                    <Col lg={4} md={6}>
                        <div className="mb-1">
                            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Postal Code</label>
                            <Field name="toAddressPostalCode" component={renderField} type="text" placeholder="Postal Code" icon={MarkAsUnreadIcon} />
                        </div>
                    </Col>
                    <Col lg={4} md={6}>
                        <div className="mb-1">
                            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Contact Name</label>
                            <Field name="toAddressContactPersonName" component={renderField} type="text" placeholder="Contact Person" icon={PersonIcon} />
                        </div>
                    </Col>
                    <Col lg={4} md={6}>
                        <div className="mb-1">
                            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Mobile Number <span className='text-danger'>*</span></label>
                            <Field name="toAddressContactNumber" component={renderField} type="text" placeholder="971xxxxxxx" validate={[required]} icon={SmartphoneIcon} />
                        </div>
                    </Col>
                </Row>
                {isMerchantCustomerAddress && merCustomerId && (
                    <MerchantCustomerAddressChangeModal modalShow={isMerchantCustomerAddress} setModalShow={setMerchantCustomerAddress} isTitle={"Change Customer Address"} merCustomerId={merCustomerId} />
                )}
                {isPopUpCustomer && (
                    <MerchantCustomerAddNewAddressModal modalShow={isPopUpCustomer} setModalShow={setPopUpCustomer} isTitle={"Add New Customer Address"} />
                )}
            </CardBody>
        </Card>
    );
};

MerchantDropOffRequiredLaterCustomerInfo.propTypes = {
    dispatch: PropTypes.func,
    isCustomersId: PropTypes.array,
};

export default connect()(reduxForm({
    form: "orderForm",
    enableReinitialize: false,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
})(MerchantDropOffRequiredLaterCustomerInfo));
